module.exports = __webpack_public_path__ + "static/media/21ECLAC22.ba37c336.jpg";